import {
  enableProdMode,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';

import { environment } from './environments/environment';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { FormBuilder } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { JwtInterceptor } from '@nutricontrol/app360-auth-shared';
import { CanActivateViaAuthGuard } from './app/services/guards/guards';
import { provideNgxMask } from 'ngx-mask';
import { bootstrapApplication } from '@angular/platform-browser';
import { CodeInputModule } from 'angular-code-input';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { AppCommonsModule } from './app/commons/app-commons.module';
import { App360BillingSharedModule } from '@nutricontrol/app360-billing-shared';
import { App360SharedModule } from '@nutricontrol/app360-shared';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      IonicModule.forRoot(),
      IonicModule,
      CodeInputModule,
      AppCommonsModule,
      App360BillingSharedModule,
      App360SharedModule
    ),
    provideRouter(routes),
    provideNoopAnimations(),
    provideZonelessChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    FormBuilder,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    CanActivateViaAuthGuard,
    { provide: 'ENVIRONMENT', useValue: environment },
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.log(err));
